import { render, staticRenderFns } from "./ModalFavorisRecette.vue?vue&type=template&id=c8f45c22&"
import script from "./ModalFavorisRecette.vue?vue&type=script&lang=js&"
export * from "./ModalFavorisRecette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports